import React, { Component } from 'react';
const type2file = {
  image: 'mini',
  audio: 'mini',
  video: 'video',
  document: 'document',
};

export default class extends Component<any> {
  public render() {
    const { type } = this.props;
    const MediaComponent = require(`./${type2file[type]}`).default;
    return <MediaComponent {...this.props} />;
  }
}
